import * as React from "react"

/**
 * @typedef {object} BaseModalProps
 * @property {React.ReactNode} [children]
 * @property {string} [className]
 */

/**
 * @type {React.FC<BaseModalProps>}
 */
const BaseModal = ({children, className = ""}) => {
  return (
    <div
      className={`
        fixed z-50 bg-dark bg-opacity-20 w-[100vw] h-screen 
        flex justify-center items-center px-4
      `}
    >
      <div
        className={`bg-white text-dark rounded-3xl p-4 w-full lg:max-w-max ${className}`}
      >
        {children}
      </div>
    </div>
  )
}

export default BaseModal
